// Formata um telefone BR para exibição: (DD) 9XXXX-XXXX / (DD) XXXX-XXXX.
// Apenas apresentação — não altera o valor armazenado. Entradas já formatadas
// ou fora do padrão de 10/11 dígitos são devolvidas como estão.
export function formatPhone(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return value || "";
}

export default formatPhone;
